import Vue from 'vue'
import Router from 'vue-router'
//目录
import index from '@/views/index/index'
import login from '@/views/login/login'
import indexPage from '@/views/indexPage/content'
import carData from '@/views/carData/carData'
import voiceData from '@/views/voiceData/voiceData'
import gasData from '@/views/gasData/gasData'
import newsData from '@/views/newsData/newsData'
import connectData from '@/views/connectData/connectData'
import applyData from '@/views/applyData/applyData'
import newsDataDetails from '@/views/newsDataDetails/newsDataDetails'
import remoteDigData from '@/views/remoteDigData/remoteDigData'

// import item  from '@/views/project/item'

import addItem from '@/views/carData/addItem'
import detail from '@/views/detail/detail'
import show from '@/views/show/show'
import showdetail from '@/views/show/components/index'
import other from '@/views/other/index'
//
import investment from '@/views/investment/index'
import password from '@/views/password/index'
// import idetail from '@/views/iDetail/index'
import detail1 from '@/views/detail/detail1'
import detail2 from '@/views/detail/detail2'
import detail3 from '@/views/detail/detail3'
import success from '@/views/success/index'


/* import success  from '@/views/success/index'
 */
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: index,
      redirect: '/indexPage'
    },


    //登陆
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'login',
        name: 'login',
        component: login
      }]
    },


    //首页
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'indexPage',
        name: 'indexPage',
        component: indexPage
      }]
    },
    //汽车大数据
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'carData',
        name: 'carData',
        component: carData
      }]
    },
    //声学大数据
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'voiceData',
        name: 'voiceData',
        component: voiceData
      }]
    },
    //天然气大数据
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'gasData',
        name: 'gasData',
        component: gasData
      }]
    },
    //遥感大数据
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'remoteDigData',
        name: 'remoteDigData',
        component: remoteDigData
      }]
    },
    //申请合作
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'applyData',
        name: 'applyData',
        component: applyData
      }]
    },
    //媒体资讯
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'newsDataDetails',
        name: 'newsDataDetails',
        component: newsDataDetails
      }]
    },
    //媒体数据
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'newsData',
        name: 'newsData',
        component: newsData
      }]
    },

    //联系我们
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'connectData',
        name: 'connectData',
        component: connectData
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'addItem',
        name: 'addItem',
        component: addItem
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'detail',
        name: 'detail',
        component: detail
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'show',
        name: 'show',
        component: show
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'showdetail',
        name: 'showdetail',
        component: showdetail
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'other',
        name: 'other',
        component: other
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'investment',
        name: 'investment',
        component: investment
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'password',
        name: 'password',
        component: password
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'detail1',
        name: 'detail1',
        component: detail1
      }]
    }, {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'detail2',
        name: 'detail2',
        component: detail2
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'detail3',
        name: 'detail3',
        component: detail3
      }]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [{
        path: 'success',
        name: 'success',
        component: success
      }]
    }
  ],
  mode: 'hash'
})



// WEBPACK FOOTER //
// ./src/router/index.js